export default `
  mutation updateEnterpriseCustomer($enterpriseUserId: String!, $input: UpdateEnterpriseCustomerInput!) {
    updateEnterpriseCustomer(enterpriseUserId: $enterpriseUserId, input: $input) {
      id
      quantity
      company
      startDate
      expirationDate
    }
  }
`
